import { getPriorityColor } from '../utils/helpers';

interface Props {
  title: string;
  subtitle: string;
  colours: {
    bgFrom: string;
    bgTo: string;
  };
}

export const Heading: React.FC<Props> = ({ colours, title, subtitle }) => {
  return (
    <div
      className='mb-3 px-4 pt-2 pb-3 border-radius'
      style={{
        background: `linear-gradient(135deg, ${colours.bgFrom} 0%, ${colours.bgTo} 100%)`,
        border: 'none',
        borderRadius: '10px',
      }}
    >
      <h3 className='strong mb-2'>{title}</h3>
      <p className='mb-3' style={{ opacity: 0.9 }}>
        {subtitle}
      </p>
      <div className='d-flex gap-3 flex-wrap'>
        <div className='d-flex align-items-center gap-2'>
          <i className={`fas fa fa-circle text-${getPriorityColor('critical')}`}/>
          <span className='text-sm'>Critical</span>
        </div>
        <div className='d-flex align-items-center gap-2'>
          <i className={`fas fa fa-circle text-${getPriorityColor('high')}`}/>
          <span className='text-sm'>High</span>
        </div>
        <div className='d-flex align-items-center gap-2'>
          <i className={`fas fa fa-circle text-${getPriorityColor('medium')}`}/>
          <span className='text-sm'>Medium</span>
        </div>
        <div className='d-flex align-items-center gap-2'>
          <i className={`fas fa fa-circle text-${getPriorityColor('low')}`}/>
          <span className='text-sm'>Low</span>
        </div>
      </div>
    </div>
  );
};
